if (!customElements.get('quick-add')) {
  customElements.define(
    'quick-add',
    class QuickAdd extends HTMLElement {
      constructor() {
        super();
        this.quickAddWrapper = this.closest('.quick-add__wrapper');
        this.quickAddOptions = this.querySelector('.quick-add__options-wrapper');
        this.optionsTrigger = this.querySelector('[data-trigger]');
        this.blurOptionsHandler = this.handleOptionsBlur.bind(this);
      }

      connectedCallback() {
        this.setEventListeners();
      }

      setEventListeners() {
        if (this.optionsTrigger) {
          this.optionsTrigger.addEventListener('click', this.handleOptionsTriggerClick.bind(this));
        }
      }

      handleOptionsTriggerClick() {
        this.showOptions();
      }

      handleOptionsBlur(e) {
        if (e.target !== this.quickAddOptions && !this.quickAddOptions.contains(e.target)) {
          this.hideOptions();
        }
      }

      showOptions() {
        this.quickAddOptions.setAttribute('data-shown', 'true');
        // if (this.querySelector('input[type="radio"]')) {
        //   this.querySelector('input[type="radio"]:first-of-type + label').click();
        // }
        setTimeout(() => document.addEventListener('click', this.blurOptionsHandler));
      }

      hideOptions() {
        document.removeEventListener('click', this.blurOptionsHandler);
        this.quickAddOptions.setAttribute('data-shown', 'false');
      }

      hide() {
        this.quickAddWrapper.style.opacity = 0;
      }
    }
  );
}